import React, { useContext, useEffect, useState } from 'react'
import { Accordion, Card } from 'react-bootstrap';
import Button from '@mui/material/Button';
import { AddBoxOutlined } from '@mui/icons-material';
import ConnUrls from '../../../../MyConns/Connections/ConnectURL';
import { HomePContext } from '../../../MyContexts/HomeP_Context';
import ImgAndTxtAndLnkCARD from '../../../MySections/DTechComps/ImgAndTxtAndLnkCARD';
import AccordSlideHeads from '../parts/AccordSlideHeads';
import EraseCheck from '../../../MySections/PopUps/EraseCheck';
import SlidItemsSelect from './SlidItemsSelect';
import utilsRestMenus from '../../../../MyConns/_Utils/utilsRestMenus';
import ItemsList from './ItemsList';

const TabCenterSliders = (props) => {
    const [homeP, setHomeP] = useContext(HomePContext);
    const [thePopUp, setThePopUp] = useState("");

    // const [slidersDisp, setSlidersDisp] = useState(homeP.CenterPSliders);
    const [slidersDisp, setSlidersDisp] = useState(props.thePage.sections || []);
    const [menuItemsList, setMenuItemsList] = useState([]);

    useEffect(() => {
        getMnuList();

    }, [])


    const getMnuList = async () => {
        let theLst = await utilsRestMenus.getLstOffAll();
        setMenuItemsList(theLst)
    }
    // const setTheCenterPSliders = (urlsList) => {
    //     homeP["CenterPSliders"] = urlsList;
    //     setBottomImagess(urlsList);
    // }


    const createNewSlide = () => {
        var newSlider = {
            sectionHead: "חדש",
            slideSubTxt: "",
            selectionType: "1",
            items: []
        }

        let tempSlide = [...slidersDisp, newSlider];
        setSlidersDisp(tempSlide);

        props.thePageUpdate("sections", tempSlide)
    }


    const removeSlide = (sldIndex) => {
        setThePopUp(<EraseCheck title={'האם בטוח למחוק את הסליידר?'} sucecssFunc={() => removeSlider(sldIndex)} />)
    }


    const removeSlider = (sldIndex) => {

        let tempSlide = [...slidersDisp];
        tempSlide.splice(sldIndex, 1);
        setSlidersDisp(tempSlide);

        props.thePageUpdate("sections", tempSlide)

    }


    const array_move = (arr, old_index, new_index) => {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };

    const setUp = (index) => {
        let temp = array_move([...slidersDisp], index, index - 1);
        setSlidersDisp(temp);

        props.thePageUpdate("sections", temp)

    }

    const setDown = (index) => {
        let temp = array_move([...slidersDisp], index, index + 1);
        setSlidersDisp(temp);

        props.thePageUpdate("sections", temp)


    }

    const changeSectionSelectionType = (slideIndex, newValue) => {
        let tempSlide = [...slidersDisp];
        tempSlide[slideIndex].selectionType = newValue;

        setSlidersDisp(tempSlide);

        props.thePageUpdate("sections", tempSlide)
    }



    const changeSectionHead = (slideIndex, newValue) => {
        let tempSlide = [...slidersDisp];
        tempSlide[slideIndex].sectionHead = newValue;

        setSlidersDisp(tempSlide);

        props.thePageUpdate("sections", tempSlide)
    }


    const changeSlideSubTxt = (slideIndex, newValue) => {
        let tempSlide = [...slidersDisp];
        tempSlide[slideIndex].slideSubTxt = newValue;

        setSlidersDisp(tempSlide);

        props.thePageUpdate("sections", tempSlide)

    }

    const changeSlideItems = (itemIndex, newVals) => {

        let tempSlide = [...slidersDisp];
        // console.log(tempSlide);
        tempSlide[itemIndex].items = newVals;
        props.thePageUpdate("sections", tempSlide)

    }

    return (
        <>
            <div className="ms-panel-body fullRow">
                <div className={"col-md-12 mb-2 onRight"}>
                    <div className={"col-md-5 mb-2 onRight"}>
                        <Button className={"addDivBtn"} variant="contained" onClick={() => createNewSlide()}
                            startIcon={<AddBoxOutlined style={{ color: 'white' }} />}>
                            הוסף סליידר
                        </Button>
                    </div>
                </div>
                {slidersDisp.map((item, index) => {
                    return (
                        <Accordion key={index} defaultActiveKey="0" className="has-gap ms-accordion-chevron selectSlideItmsAcord fullRow">
                            <Card >
                                <Accordion.Collapse className="collapseparent" eventKey={"sld" + index}>
                                    <Card.Body style={{ color: 'black' }}>
                                        <Accordion defaultActiveKey="0" className="has-gap ms-accordion-chevron selectSlideItmsAcord">
                                            <AccordSlideHeads
                                                index={index}
                                                sectionHead={item.sectionHead}
                                                changeSectionHead={(slideIndex, newValue) => changeSectionHead(slideIndex, newValue)}
                                                slideSubTxt={item.slideSubTxt}
                                                changeSlideSubTxt={(slideIndex, newValue) => changeSlideSubTxt(slideIndex, newValue)}
                                            />
                                            <SlidItemsSelect slideItem={item}
                                                changeSectionSelectionType={(newValue) => changeSectionSelectionType(index, newValue)} />

                                            <ItemsList itmsLst={menuItemsList}
                                                slideItem={item}
                                                changeSlideItems={(newValue) =>
                                                    changeSlideItems(index, newValue)} />
                                        </Accordion>
                                    </Card.Body>
                                </Accordion.Collapse>
                                <Accordion.Toggle as={Card.Header} eventKey={"sld" + index}>
                                    <span>{item.sectionHead}</span><span className={"noBold"}></span>
                                </Accordion.Toggle>

                                <div className={"acoordBtns"}>
                                    <div className={"acoordIcon acord1 pointing"} onClick={() => removeSlide(index)}><i className="far fa-trash-alt theSecIconsColor onLeft" /></div>
                                    {index != 0 && slidersDisp.length > 1 ? <div className={"acoordIcon acord2 pointing"} onClick={() => setUp(index)} title={"הקפץ למעלה"}><i className="far fa-caret-square-up theSecIconsColor onLeft" /></div> : ""}
                                    {index < slidersDisp.length - 1 ? <div className={"acoordIcon acord3 pointing"} onClick={() => setDown(index)} title={"הקפץ למטה"}><i className="far fa-caret-square-down theSecIconsColor onLeft" /></div> : ""}
                                </div>
                            </Card >
                        </Accordion>
                    )
                })}
            </div>
            {thePopUp}
        </>

    );
}

export default TabCenterSliders;